<div class="wrapper">
	<div class="main">
		<dashboard-navbar></dashboard-navbar>
		<main class="content">
            <router-outlet></router-outlet>
		</main>
		<dashboard-chatbot></dashboard-chatbot>
		<dashboard-footer></dashboard-footer>
	</div>
</div>